import { ReactElement, memo } from 'react';
import { Stack } from '@mui/material';

import { PATHS } from '~constants/paths';
import { replaceParamsPath } from '~utils/router';

import {
  classes,
  DescriptionWithIconBoxText,
} from '../DescriptionWithIconBox/styles';
import Link from '../Link';

import { TemplateNameInfoProps } from './types';

const TemplateNameInfo = ({
  templateName,
  templateCode,
  routeId,
  apiTransactionId,
}: TemplateNameInfoProps): ReactElement => (
  <Stack spacing={0.75}>
    <DescriptionWithIconBoxText
      variant="body2"
      className={classes.descriptionText}
    >
      {templateName}
    </DescriptionWithIconBoxText>

    <Link
      to={replaceParamsPath(PATHS.ROUTES.VEHICLE_PLANNING, {
        ':apiTransactionId': apiTransactionId,
        ':routeId': routeId,
      })}
      color="primary"
      variant="inherit"
      underline="hover"
      fontWeight="bold"
      sx={{ fontSize: 12 }}
    >
      {`#${templateCode}`}
    </Link>
  </Stack>
);

export default memo(TemplateNameInfo);
